import { LRUCache } from "lru-cache";

export const remembering = <V>(limit: number): ((key: string, build: () => V) => V) => {
  const kept = new LRUCache<string, { readonly value: V }>({ max: limit });
  return (key, build) => {
    const known = kept.get(key);
    if (known !== undefined) return known.value;
    const value = build();
    kept.set(key, { value });
    return value;
  };
};
